export enum ReactionType {
  FIST = "hu-fist",
  STRONG = "hu-strong",
  UP = "hu-up",
  DOWN = "hu-down",
  HAHA = "hu-haha",
}
